import React from 'react';
import ReactDOM from 'react-dom/client';
import { App, AppProviders } from '@/app';
import { ErrorBoundary } from '@/components/feedback';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>
);
